import React, { useEffect, useState, useMemo } from 'react';
import { getAllDriver } from '../../../../Core/Services/InternalUser/ControllerService/driverService';
import { useToast } from '../../../../Core/Hooks/useToast';
import { EditButton, DataGrid, BreadCrumbs, formatters } from '../../../../Core/Controls';
import { getAllVor, getVorByVehicle } from '../../../../Core/Services/InternalUser/VOR/addEditVor';
import AddVor from './AddEditVor';
import DialogComp from '../../../../Core/Dialog/DialogComp';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';

import '../../../commonStyle.scss';
import { Link } from 'react-router-dom';
import GijgoGrid from '../../../../Core/Controls/GijgoGrid';
import BuildIcon from '@material-ui/icons/Build';

import DepotDetails from '../DetailsModal/depotDetails';
import { useHistory } from 'react-router-dom';
import ReactDOM from 'react-dom';
import CustomerDetails from '../DetailsModal/customerDetails';
import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import { AppStorage } from '../../../../Core/Basic/storage-service';
import WorkIcon from '@material-ui/icons/Work';
import moment from 'moment';
import { GetSchedulesExcelFile, GetVORExcelFile, GetVORReportingExcelFile } from '../../../../Core/Services/InternalUser/excelDownload';
import Vor from './../../../VOR/vorTypesScreen/VorType';
import { Tooltip } from '@material-ui/core';

const baseColumns = [
    {
        key: 'action',
        name: 'Action',
        width: 104,
        addFileUploaderIcon: true
    },

    { key: 'vorVehicleDateStarted', name: 'Start Date', width: 120, formatter: formatters.Date_DDMMMYYYY_HHMM },
    { key: 'daysdiff', name: 'Days off road', width: 90 },
    { key: 'vorVehicleLocation', name: 'Repair Agent', width: '300' },
    // { key: 'vorTypeDescription', name: 'Type', width: '180' },
    { key: 'vorDelayReason', name: 'VOR Delay Reason', width: '120' },
    // { key: 'vehicleCategoryDescription', name: 'Sub Category', width: '120' },
    // { key: 'make', name: 'Make', width: '120' },
    // { key: 'makeContactName', name: 'Make Contact', width: '120' },
    { key: 'progressNotes', name: 'VOR Progress Notes', width: '250', filterable: 'no' }
    // { key: 'lastUpdateDate', name: 'Date/Time Last Update', width: '140', formatter: formatters.Date_DDMMMYYYY_HHMM },
    // { key: 'lastUpdate', name: 'Last Update', width: '100' }
];
const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'VOR', active: true }
];

let showVorDelayDetails = (id, row) => {
    switch (id) {
        case 1: // Booking delay/lead time
            return (
                `Booking delay/lead time\n` +
                `Date Escalated = ${row.vorVehicleEscalationDate ? moment(row.vorVehicleEscalationDate).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Escalated To = ${row.vorVehicleEscalationTo || 'N/A'}`
            );

        case 2: // Technical Delay
            return (
                `Technical Delay\n` +
                `Technical Case No = ${row.vorVehicleTechnicalCaseNo || 'N/A'}\n` +
                `Date Logged = ${row.vorVehicleTechnicalDelayDateLogged ? moment(row.vorVehicleTechnicalDelayDateLogged).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Date Escalated = ${row.vorVehicleEscalationDate ? moment(row.vorVehicleEscalationDate).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Escalated To = ${row.vorVehicleEscalationTo || 'N/A'}`
            );

        case 3: // Parts Delay
            return (
                `Parts Delay\n` +
                `Part Number = ${row.vorVehiclePartDelayPartNo || 'N/A'}\n` +
                `Date Ordered = ${row.vorVehiclePartDelayDateOrder ? moment(row.vorVehiclePartDelayDateOrder).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Order No = ${row.vorVehiclePartDelayOrderNumber || 'N/A'}\n` +
                `Date Escalated = ${row.vorVehicleEscalationDate ? moment(row.vorVehicleEscalationDate).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Escalated To = ${row.vorVehicleEscalationTo || 'N/A'}`
            );

        case 4: // Technician availability
            return (
                `Technician availability\n` +
                `Date Escalated = ${row.vorVehicleEscalationDate ? moment(row.vorVehicleEscalationDate).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Escalated To = ${row.vorVehicleEscalationTo || 'N/A'}`
            );

        case 5: // Other
            return (
                `Other\n` +
                `Type Message = ${row.vorVehicleOtherMessage || 'N/A'}\n` +
                `Date Escalated = ${row.vorVehicleEscalationDate ? moment(row.vorVehicleEscalationDate).format('DD/MM/YYYY') : 'N/A'}\n` +
                `Escalated To = ${row.vorVehicleEscalationTo || 'N/A'}`
            );

        default:
            return '';
    }
};

let VorScreenToolTip = (row) => {
    return showVorDelayDetails(row.vorVehicleDelayReasonID, row);
};

const VorScreen = (props) => {
    const { showToastError } = useToast();
    console.log(props, 'props in vor screen');
    const FromDash = props.location?.query?.FromDash;
    let checkhaveAccess = AppStorage.getAllowAcces();

    const [state, setState] = useState({
        show: false,
        showLoader: true,
        VorList: [],
        DriverID: null,
        checkedA: true,
        filterFlag: FromDash ? true : false,
        activeOrInactive: FromDash ? true : false,
        vorFlag: FromDash ? true : '',
        isReload: null,
        getUrl: props.VehicleID
            ? `VORVehicles?VehicleID=${props.VehicleID}`
            : `VORVehicles?active=${FromDash ? true : ''}&StartDate=${props.location.startDate ? props.location.startDate : ''}&EndDate=${
                  props.location.endDate ? props.location.endDate : ''
              }&CustomerId=${props.location.customerID ? props.location.customerID : ''}&Make=${props.location.make ? props.location.make : ''}&Model=${
                  props.location.model ? props.location.model : ''
              }`
    });

    useEffect(() => {
        if (!FromDash) {
            if (props.VehicleID) {
                setState((st) => ({
                    ...st,
                    getUrl: `VORVehicles?VehicleID=${props.VehicleID}`,
                    vorFlag: false
                }));
            } else {
                const vorFilterFlag = JSON.parse(localStorage.getItem('VORFilterFlag'));
                if (vorFilterFlag) {
                    setState((st) => ({
                        ...st,
                        filterFlag: vorFilterFlag.filterFlag,
                        activeOrInactive: vorFilterFlag.activeOrInactive,
                        vorFlag: vorFilterFlag.filterFlag ? true : '',
                        getUrl: `VORVehicles?active=${vorFilterFlag.filterFlag ? true : ''}`
                    }));
                }
            }
        } else if (FromDash) {
            localStorage.setItem('VORFilterFlag', JSON.stringify({ filterFlag: true, activeOrInactive: true }));
        }
    }, []);

    // long? CustomerId,  string Make,string Model

    let history = useHistory();

    const handleChange = (event) => {
        const { name, checked } = event.target;
        let tempSt = {};
        if (name === 'filterFlag') {
            localStorage.setItem('VORFilterFlag', JSON.stringify({ filterFlag: checked, activeOrInactive: checked ? true : false }));

            tempSt = {
                filterFlag: checked,
                activeOrInactive: checked ? true : false,
                vorFlag: checked ? true : ''
            };
        } else if (name === 'activeOrInactive') {
            tempSt = {
                activeOrInactive: checked,
                vorFlag: checked
            };
        }

        setState((st) => ({ ...st, ...tempSt, getUrl: `VORVehicles?active=${tempSt.vorFlag}` }));
    };

    const handleAdd = (data) => {
        setState((st) => ({
            ...st,
            show: true,
            vorVehicleID: data.vorVehicleID,
            regNo: data.vehicleRegNumber,
            VehicleID: data.vorVehicleVehicleID
        }));
    };

    const closeVorModal = (res) => {
        setState((st) => {
            let newSt = { ...st };
            if (res) {
                newSt.isReload = new Date();
            }
            newSt.show = false;

            return newSt;
        });
        // res && pullAllVor();
    };
    const handleEditDefect = (val) => {
        if (val.defectTypeCode == 'DD') {
            history.push({
                pathname: `/maintenance/defect/edit/${val?.defectID}/${val?.vorVehicleVehicleID}`,
                state: 'Edit'
            });
        } else {
            history.push({
                pathname: `/maintenance/breakdowns/edit/${val?.defectID}/${val?.vorVehicleVehicleID}`,
                state: 'Edit'
            });
        }
    };
    const handleEditClick = (val) => {
        history.push({
            pathname: `/controller/jobTabScreen/${val?.jobID}/${val?.vorVehicleVehicleID}`,
            search: '',
            state: 'jobs'
        });
    };
    const dataFormatter = (data, row) => {
        return (
            <div style={{ textAlign: 'left' }}>
                <EditButton toolTipTitle="Edit Vor" onClick={() => handleAdd(row)} />
                {row.defectID && (
                    <CustomIconButton
                        icon={BuildIcon}
                        color="secondary"
                        className="modal-btn-update btn_space"
                        // onClick={() => handleUpdate(row, null, 'modalEditDetail')}
                        onClick={() => handleEditDefect(row)}
                        toolTipTitle="Edit Defect"
                    />
                )}
                {checkhaveAccess?.CanViewJobs && row.jobID && (
                    <CustomIconButton icon={WorkIcon} className="modal-btn-update btn_space" toolTipTitle="Edit Job" onClick={() => handleEditClick(row)} />
                )}
            </div>
        );
    };
    const delayReasonColFormatter = (data, row) => {
        let obj = data.row;
        const spn = document.createElement('span');
        const lnk = (
            // <div lable="Click to edit VOR Delay Reason" arrow style={{ padding: 0, textDecoration: 'none' }}>
            <Grid item title={VorScreenToolTip(obj)}>
                {obj.vorDelayReason}
            </Grid>
            // </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handelRowCick = (row, name) => {
        setState((st) => ({
            ...st,
            selectedRowData: row,
            [name]: true
        }));
    };

    const handleEditRegClick = (val) => {
        history.push({
            pathname: `/controller/editVehicle/${val.vorVehicleVehicleID}`,
            search: '',
            state: { fileCount: val.fileCount }
        });
    };

    const renderRegNumberEdit = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handleEditRegClick(row)} style={{ cursor: 'pointer', color: row.txtcolor || 'black', fontWeight: 'bold' }}>
                {row.vehicleRegNumber}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const renderDepotName = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handelRowCick(row, 'showDepotModal')} style={{ cursor: 'pointer', color: row.txtcolor || 'black', fontWeight: 'bold' }}>
                {row.depotName}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const renderCustomerName = ({ row, col }, grid) => {
        const spn = document.createElement('span');
        const lnk = (
            <div onClick={() => handelRowCick(row, 'showCustomerModal')} style={{ cursor: 'pointer', color: row.txtcolor || 'black', fontWeight: 'bold' }}>
                {row.customerCompanyName}
            </div>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const handleClose = () => {
        setState((st) => ({
            ...st,
            open: false,
            showSaModal: false,
            showCustomerModal: false,
            showDepotModal: false
        }));
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.key === 'action');
        let delayReasonCol = tempCols.find((element) => element.key === 'vorDelayReason');
        // if (state.activeOrInactive) {
        //     tempCols.splice(3, 0, { key: 'vorVehicleEstimatedEndDate', name: 'Estimated Completion', width: '10%', formatter: formatters.Date_DDMMYYYY });
        // } else {
        //     tempCols.splice(2, 0, { key: 'vorVehicleDateEnded', name: 'End Date', width: 140, formatter: formatters.Date_DDMMMYYYY_HHMM });
        // }
        if (actionCol) {
            actionCol.formatter = dataFormatter;
        }
        if (delayReasonCol) {
            delayReasonCol.formatter = delayReasonColFormatter;
        }
        if (!props.VehicleID) {
            tempCols.splice(1, 0, { key: 'vehicleRegNumber', name: 'Reg Number', width: 90, formatter: renderRegNumberEdit });
            tempCols.splice(2, 0, { key: 'customerCompanyName', name: 'Customer', width: '120', formatter: renderCustomerName });
            tempCols.splice(3, 0, { key: 'depotName', name: 'Depot', width: '120', formatter: renderDepotName });
        }
        return tempCols;
    }, [state.activeOrInactive]);

    const onRowDataBound = (e, $row, id, record) => {
        // const lastUpdateDate = moment(record.lastUpdateDate).format('MM/DD/YYYY');
        // const daysPast = moment().diff(lastUpdateDate, 'days');
        if (record.bgcolor) $row.css('background-color', `${record.bgcolor}`);
        else $row.css('background-color', 'white');
    };

    const onCellDataBound = (e, $displayEl, id, column, record) => {
        if (record.txtcolor) $displayEl.css('color', record.txtcolor);
        else $displayEl.css('color', 'black');
    };

    return (
        <div className={`${!props.VehicleID && 'screen'}` + ' controller-screen'} style={{ position: 'relative' }}>
            {state.show ? (
                // <AddEditDriver DriverID={state.DriverID} onFormSubmit={closeDriverModal} />
                <DialogComp title={`Update VOR - ${state.regNo}`} onClose={() => closeVorModal(false)} fullScreen overflow="auto">
                    <AddVor vorVehicleID={state.vorVehicleID} update={true} onClose={closeVorModal} VehicleID={props.VehicleID || state.VehicleID} />
                </DialogComp>
            ) : null}
            {!props.VehicleID && <BreadCrumbs crumbs={crumbs} />}
            {!props.VehicleID && (
                <Grid container item className="switchBtnContainer">
                    <Grid component="label" item className="childSwitchBtnContainer" alignItems="center">
                        <Grid item>Filter : Off</Grid>
                        <Grid item>
                            <Switch checked={state.filterFlag} onChange={handleChange} value="checked" name="filterFlag" />
                        </Grid>
                        <Grid item>On</Grid>
                    </Grid>
                    <Grid component="label" item className="childSwitchBtnContainer" alignItems="center">
                        <Grid item>Inactive</Grid>
                        <Grid item>
                            <Switch
                                checked={state.activeOrInactive}
                                onChange={handleChange}
                                value="checked"
                                name="activeOrInactive"
                                disabled={!state.filterFlag}
                            />
                        </Grid>
                        <Grid item>Active</Grid>
                    </Grid>
                </Grid>
            )}

            <GijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                onRowDataBound={(e, $row, id, record) => onRowDataBound(e, $row, id, record)}
                onCellDataBound={(e, $displayEl, id, column, record) => onCellDataBound(e, $displayEl, id, column, record)}
                columns={columns}
                getUrl={state.getUrl}
                btnTitle=""
                onBtnClick={handleAdd}
                isReload={state.isReload}
                filterVal={props?.location?.state || {}}
                idFieldName="vorVehicleID"
                fileUploaderConfigName="VOR"
                downloadBtnName="Download xlsx"
                downloadCustomUrl={() =>
                    GetVORReportingExcelFile({
                        fromDate: props.location?.startDate || '',
                        toDate: props.location?.endDate || '',
                        customerID: props.location?.customerID || '',
                        vehicleCategoryID: '',
                        makeID: '',
                        fileExt: 'xlsx',
                        active: state.vorFlag || '',
                        VehicleID: props.VehicleID || ''
                    })
                }
            />
            {state.showCustomerModal ? (
                <DialogComp open={true} onClose={handleClose} title={'Customer Details'}>
                    <CustomerDetails customerID={state.selectedRowData.customerID} onFormSubmit={handleClose} />
                </DialogComp>
            ) : null}
            {state.showDepotModal ? (
                <DialogComp open={true} onClose={handleClose} title={'Depot Details'}>
                    <DepotDetails customerID={state.selectedRowData.depotID} onFormSubmit={handleClose} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default VorScreen;
